// extracted by mini-css-extract-plugin
export default {"root":"ConfirmationForm_root__DF6i+","buttons":"ConfirmationForm_buttons__QUXv2","cancelBtn":"ConfirmationForm_cancelBtn__AlF4m","yesBtn":"ConfirmationForm_yesBtn__VrD66"};